// extracted by mini-css-extract-plugin
module.exports = {"PlaceHolder":"PlaceHolder_PlaceHolder__1IhIE"};